<template lang="pug">
div.small-space
  .label.is-small {{initBlock.config.label}}
  template(v-if="media && media.isPdf")
    img(src="@/assets/pdf_icon.svg" width="100px")
    p Dateiname: {{media.name}}
  img(v-else-if="media && media.thumbnailUrl" :src="media.thumbnailUrl")
  .spacer.sm
  .button-wrapper
    b-button(type="is-flat" @click="show = true") Bild auswählen
    UploadMedia(@update="getMedias()" :id="null" @close="() => {}" iconOnly)
  b-modal(v-model="show"
        has-modal-card
        :full-screen="false" 
        :can-cancel="true")
    SelectMediaModal(@select="(data) => updateValue(data)")
</template>

<script>
import SelectMediaModal from '@/components/molecules/SelectMediaModal.vue';
import UploadMedia from '@/components/molecules/UploadMedia.vue';

export default {
  components: {
    SelectMediaModal,
    UploadMedia
  },
  props: {
    parentKey: String,
    initBlock: {
      type: Object,
      default() {
        return {
          value: {
            thumbnailUrl: null
          },
          config: null
        }
      }
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    medias() {
      return this.$store.state.medias.all;
    },
    media() {
      if (!this.initBlock.value && !this.initBlock.value.id) return undefined;
      return this.medias.find(m => m.id === this.initBlock.value.id);
    }
  },
  methods: {
    updateValue(e) {
      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          ...e
        }
      });
      this.show = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.small-space {
  margin-bottom: 24px;
}
</style>